'use strict';

var _regeneratorRuntime = require("/ws/61941e029dd8eb000197c556/095e8b3251cd4da4bfbd4c9ec23a8ade/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/ws/61941e029dd8eb000197c556/095e8b3251cd4da4bfbd4c9ec23a8ade/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

var _asyncToGenerator = require("/ws/61941e029dd8eb000197c556/095e8b3251cd4da4bfbd4c9ec23a8ade/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var CID = require('cids');

var multipartRequest = require('../../lib/multipart-request');

var configure = require('../../lib/configure');

var toUrlSearchParams = require('../../lib/to-url-search-params');

var abortSignal = require('../../lib/abort-signal');

var _require = require('native-abort-controller'),
    AbortController = _require.AbortController;

module.exports = configure(function (api) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(cid, data) {
      var options,
          controller,
          signal,
          res,
          _yield$res$json,
          Hash,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
              // allow aborting requests on body errors
              controller = new AbortController();
              signal = abortSignal(controller.signal, options.signal); // @ts-ignore https://github.com/ipfs/js-ipfs-utils/issues/90

              _context.t0 = api;
              _context.t1 = _objectSpread;
              _context.t2 = {
                timeout: options.timeout,
                signal: signal,
                searchParams: toUrlSearchParams(_objectSpread({
                  arg: "".concat(cid instanceof Uint8Array ? new CID(cid) : cid)
                }, options))
              };
              _context.next = 8;
              return multipartRequest(data, controller, options.headers);

            case 8:
              _context.t3 = _context.sent;
              _context.t4 = (0, _context.t1)(_context.t2, _context.t3);
              _context.next = 12;
              return _context.t0.post.call(_context.t0, 'object/patch/append-data', _context.t4);

            case 12:
              res = _context.sent;
              _context.next = 15;
              return res.json();

            case 15:
              _yield$res$json = _context.sent;
              Hash = _yield$res$json.Hash;
              return _context.abrupt("return", new CID(Hash));

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
});